"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Image_1 = __importDefault(require("../Image"));
var config_1 = __importDefault(require("../config"));
var TRANSFORMATION_DELIMINETER = '-';
exports.getMediaManagerUrl = function (picture, width, height, script) {
    if (script === void 0) { script = 'resize'; }
    if (!picture) {
        return '';
    }
    var transformOperations = [];
    if (picture.dimensions) {
        var _a = picture.dimensions, X = _a.X, Y = _a.Y, W = _a.W, H = _a.H;
        transformOperations.push(X + "x" + Y + "x" + W + "x" + H);
    }
    transformOperations.push(width + "x" + height + "x" + script);
    var size = transformOperations.join(TRANSFORMATION_DELIMINETER);
    if (picture.media_url) {
        return picture.media_url.replace('{size}', size);
    }
    else if (picture.uri) {
        return config_1.default.MEDIAMANAGER_URL + "/images/" + size + "/" + picture.uri;
    }
    return '';
};
var MediaManagerImage = /** @class */ (function (_super) {
    __extends(MediaManagerImage, _super);
    function MediaManagerImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaManagerImage.prototype.render = function () {
        var _a = this.props, picture = _a.picture, script = _a.script, naturalHeight = _a.naturalHeight, naturalWidth = _a.naturalWidth, restProps = __rest(_a, ["picture", "script", "naturalHeight", "naturalWidth"]);
        var src = exports.getMediaManagerUrl(picture, naturalWidth, naturalHeight, script);
        return React.createElement(Image_1.default, __assign({}, restProps, { src: src || '' }));
    };
    return MediaManagerImage;
}(React.Component));
exports.default = MediaManagerImage;
